"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "CartModel", {
  enumerable: true,
  get: function get() {
    return _model.default;
  }
});
_Object$defineProperty(exports, "CartType", {
  enumerable: true,
  get: function get() {
    return _type.default;
  }
});
exports.default = void 0;
var _reducer = _interopRequireDefault(require("./reducer"));
var _actions = _interopRequireDefault(require("./actions"));
var _type = _interopRequireDefault(require("./type"));
var _model = _interopRequireDefault(require("./model"));
function cov_2mtfzudttu() {
  var path = "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/cart/lib/index.js";
  var hash = "3b5aa2803f4e7c0415552780e68499e82f693ea3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/cart/lib/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3b5aa2803f4e7c0415552780e68499e82f693ea3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2mtfzudttu = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2mtfzudttu();
var _default = exports.default = {
  reducer: _reducer.default,
  actions: _actions.default
};